module.exports = __webpack_public_path__ + "img/classPhotoes-active.a0d24d73.svg";